import { atom } from 'jotai';
import { SnackbarMessage } from '@/types';

export const snackbarMessage = atom<SnackbarMessage>({ shouldShow: false });

export const userManagementSearchPlaceholder = atom<string>('Search Users');

export const userManagementSearchTerm = atom<string>('');
